import * as React from 'react';
import { Link } from 'react-router-dom';

// Legal pages, German only as is usual. Texts are drafts: every [ ... ] placeholder must be filled
// and the whole text checked by a lawyer before going live.

const legalLinks = [
    { to: "/impressum", text: "Impressum" },
    { to: "/datenschutz", text: "Datenschutz" },
    { to: "/agb", text: "AGB" },
];

// the one list of legal links, used on the landing page, the login and the app footer
export const LegalLinks: React.FC<{ className?: string }> = ({ className }) => (
    <>{legalLinks.map(l => <Link key={l.to} className={className} to={l.to}>{l.text}</Link>)}</>
);

const LegalPage: React.FC<{ title: string, children: React.ReactNode }> = ({ title, children }) => (
    <div className="c-landing">
        <div className="c-landing__wrap">
            <header className="c-landing__top">
                <Link className="c-landing__brand" to="/welcome"><b>MOPS<i>.</i></b><span>Machine Operating and Planning System</span></Link>
            </header>
            <section className="c-landing__legal">
                <h1>{title}</h1>
                {children}
            </section>
            <footer className="c-landing__footer">
                <span>MOPS · Machine Operating and Planning System</span>
                <nav className="c-landing__legal-links" aria-label="Rechtliches"><LegalLinks /></nav>
            </footer>
        </div>
    </div>
);

export const Impressum: React.FC = () => (
    <LegalPage title="Impressum">
        <h3>Angaben gemäß § 5 DDG</h3>
        <p>
            [Firmenname inkl. Rechtsform]<br />
            [Straße Hausnummer]<br />
            [PLZ Ort]<br />
            [Land]
        </p>

        <h3>Vertreten durch</h3>
        <p>[Name des Geschäftsführers / Inhabers]</p>

        <h3>Kontakt</h3>
        <p>
            Telefon: [Telefonnummer]<br />
            E-Mail: <a href="mailto:[E-Mail-Adresse]">[E-Mail-Adresse]</a>
        </p>

        <h3>Registereintrag</h3>
        <p>
            Registergericht: [Amtsgericht]<br />
            Registernummer: [HRB ...]
        </p>

        <h3>Umsatzsteuer-ID</h3>
        <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: [DE...]</p>
    </LegalPage>
);

export const Datenschutz: React.FC = () => (
    <LegalPage title="Datenschutz">
        <p>Stand: [Oktober 2026]</p>

        <h3>1. Verantwortlicher</h3>
        <p>
            Verantwortlich für die Verarbeitung personenbezogener Daten auf dieser Website und in MOPS ist der im <Link to="/impressum">Impressum</Link> genannte Anbieter.
            Datenschutzanfragen richten Sie bitte an <a href="mailto:[Datenschutz-E-Mail]">[Datenschutz-E-Mail]</a>.
        </p>
        <p>[Falls ein Datenschutzbeauftragter benannt ist: Name und Kontakt]</p>

        <h3>2. Hosting</h3>
        <p>
            Website, Anwendung und Datenbank werden bei Microsoft Azure betrieben (Microsoft Ireland Operations Ltd., One Microsoft Place, South County Business Park, Leopardstown, Dublin 18, Irland),
            in der Region [EU-Region, z. B. Germany West Central]. Mit Microsoft besteht ein Vertrag zur Auftragsverarbeitung nach Art. 28 DSGVO.
            Microsoft ist unter dem EU-US Data Privacy Framework zertifiziert; soweit Daten im Einzelfall in die USA gelangen können, ist das die Grundlage (Art. 45 DSGVO).
        </p>

        <h3>3. Aufruf der Website, Server-Logs und Fehlerprotokolle</h3>
        <p>
            Beim Aufruf verarbeitet der Server technisch notwendige Daten: IP-Adresse, Datum und Uhrzeit, aufgerufene Adresse, Browser- und Betriebssystemangaben.
            Zur Fehleranalyse und Absicherung des Betriebs zeichnen wir außerdem technische Protokolle der Anwendung auf (Microsoft Application Insights), etwa Anfragen, Antwortzeiten und Fehlermeldungen.
            Rechtsgrundlage ist unser berechtigtes Interesse an einem sicheren und stabilen Betrieb (Art. 6 Abs. 1 lit. f DSGVO). Die Protokolle werden nach [Anzahl] Tagen gelöscht.
        </p>

        <h3>4. Keine Cookies, kein Tracking</h3>
        <p>
            Wir setzen keine Analyse-, Werbe- oder Tracking-Werkzeuge ein und laden keine Inhalte von Drittanbietern; auch die Schriften liegen auf unserem eigenen Server.
            Nach der Anmeldung speichern wir im lokalen Speicher Ihres Browsers (localStorage) ein Anmelde-Token, damit Sie angemeldet bleiben.
            Das ist für den von Ihnen gewünschten Dienst unbedingt erforderlich (§ 25 Abs. 2 Nr. 2 TDDDG) und wird beim Abmelden gelöscht.
        </p>

        <h3>5. Registrierung und Kundenkonto</h3>
        <p>
            Bei der Registrierung verarbeiten wir E-Mail-Adresse, Benutzername, Passwort (nur verschlüsselt gespeichert), Name und Vorname, Firmen- bzw. Kontoname sowie die Anschrift.
            Für die Abrechnung kommen Rechnungsanschrift, Zahlungsart und Rechnungstag hinzu. Ihre Einstellungen (Sprache, Darstellung) speichern wir in Ihrem Konto.
            Rechtsgrundlage ist die Erfüllung des Vertrags (Art. 6 Abs. 1 lit. b DSGVO).
        </p>

        <h3>6. Daten, die Sie in MOPS erfassen</h3>
        <p>
            In MOPS erfassen Kunden Daten zu Maschinen, Tagesberichten, Tankvorgängen, Defekten, Wartungen und Aufgaben sowie die Konten ihrer Mitarbeiter.
            Diese Daten verarbeiten wir im Auftrag des Kunden nach Art. 28 DSGVO; Verantwortlicher ist insoweit der Kunde. Dazu schließen wir mit jedem Kunden einen Vertrag zur Auftragsverarbeitung.
            Mitarbeiter, die von ihrem Arbeitgeber in MOPS eingeladen wurden, wenden sich mit Fragen zu ihren Daten bitte zuerst an ihren Arbeitgeber.
        </p>

        <h3>7. E-Mails</h3>
        <p>
            Wir versenden nur E-Mails, die für das Konto nötig sind: Bestätigung der Registrierung, Einladung neuer Benutzer, Zurücksetzen des Passworts und Bestätigung der Kontolöschung.
            Der Versand läuft über [E-Mail-Anbieter, Sitz]. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO. Newsletter oder Werbe-E-Mails versenden wir nicht.
        </p>

        <h3>8. Speicherdauer und Löschung</h3>
        <p>
            Wir speichern Ihre Daten, solange Ihr Konto besteht. Sie können Ihr Konto in den Kontoeinstellungen selbst löschen; nach Bestätigung per E-Mail werden das Konto und alle Daten Ihres Kontos gelöscht.
            Rechnungsrelevante Unterlagen bewahren wir aufgrund handels- und steuerrechtlicher Pflichten bis zu zehn Jahre auf (§ 257 HGB, § 147 AO).
        </p>

        <h3>9. Ihre Rechte</h3>
        <p>Sie haben das Recht auf</p>
        <ul>
            <li>Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO),</li>
            <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO),</li>
            <li>Löschung (Art. 17 DSGVO) und Einschränkung der Verarbeitung (Art. 18 DSGVO),</li>
            <li>Datenübertragbarkeit (Art. 20 DSGVO),</li>
            <li>Widerspruch gegen Verarbeitungen auf Grundlage berechtigter Interessen (Art. 21 DSGVO).</li>
        </ul>
        <p>
            Außerdem können Sie sich bei einer Datenschutz-Aufsichtsbehörde beschweren (Art. 77 DSGVO), zum Beispiel bei der für uns zuständigen: [Aufsichtsbehörde des Bundeslandes, Anschrift].
        </p>

        <h3>10. Keine automatisierten Entscheidungen</h3>
        <p>Eine automatisierte Entscheidungsfindung einschließlich Profiling nach Art. 22 DSGVO findet nicht statt.</p>
    </LegalPage>
);

export const Agb: React.FC = () => (
    <LegalPage title="AGB">
        <p>Allgemeine Geschäftsbedingungen für die Nutzung von MOPS. Stand: [Oktober 2026]</p>

        <h3>§ 1 Geltungsbereich</h3>
        <p>
            Diese AGB gelten für alle Verträge zwischen [Firmenname] („Anbieter“) und seinen Kunden über die Nutzung der Software MOPS.
            MOPS richtet sich ausschließlich an Unternehmer im Sinne von § 14 BGB, juristische Personen des öffentlichen Rechts und öffentlich-rechtliche Sondervermögen.
            Abweichende Bedingungen des Kunden gelten nur, wenn der Anbieter ihnen ausdrücklich schriftlich zustimmt.
        </p>

        <h3>§ 2 Vertragsgegenstand</h3>
        <p>
            Der Anbieter stellt MOPS als Software-as-a-Service über das Internet zur Nutzung im Browser bereit. Der Funktionsumfang richtet sich nach dem gewählten Tarif,
            insbesondere der Anzahl der Maschinen und Benutzer sowie den enthaltenen Modulen (z. B. Defekte, Aufgaben). Eine Überlassung der Software zur Installation erfolgt nicht.
        </p>

        <h3>§ 3 Vertragsschluss und Konto</h3>
        <p>
            Der Vertrag kommt zustande, wenn der Kunde sich registriert und seine E-Mail-Adresse bestätigt. Der Kunde ist für die Richtigkeit seiner Angaben verantwortlich.
            Der registrierende Benutzer verwaltet das Konto des Kunden und kann weitere Benutzer einladen.
        </p>

        <h3>§ 4 Verfügbarkeit</h3>
        <p>
            Der Anbieter bemüht sich um eine Verfügbarkeit von [99] % im Jahresmittel. Ausgenommen sind angekündigte Wartungsfenster und Störungen, die der Anbieter nicht zu vertreten hat,
            etwa Störungen des Internets oder höhere Gewalt.
        </p>

        <h3>§ 5 Pflichten des Kunden</h3>
        <ul>
            <li>Zugangsdaten geheim halten und Unbefugten keinen Zugang ermöglichen,</li>
            <li>MOPS nur im Rahmen der geltenden Gesetze nutzen und keine rechtswidrigen Inhalte speichern,</li>
            <li>für die Daten seiner Mitarbeiter die datenschutzrechtlichen Pflichten des Verantwortlichen erfüllen,</li>
            <li>Störungen und Sicherheitsvorfälle unverzüglich melden.</li>
        </ul>

        <h3>§ 6 Preise und Zahlung</h3>
        <p>
            Es gelten die bei Vertragsschluss vereinbarten Preise des gewählten Tarifs zuzüglich gesetzlicher Umsatzsteuer. Die Abrechnung erfolgt [monatlich im Voraus] zum vereinbarten Rechnungstag.
            Rechnungen sind innerhalb von [14] Tagen ohne Abzug zahlbar. Bei Zahlungsverzug von mehr als [30] Tagen kann der Anbieter den Zugang nach vorheriger Ankündigung sperren.
        </p>

        <h3>§ 7 Laufzeit und Kündigung</h3>
        <p>
            Der Vertrag läuft auf unbestimmte Zeit und kann von beiden Seiten mit einer Frist von [einem Monat zum Monatsende] gekündigt werden.
            Der Kunde kann sein Konto jederzeit in den Kontoeinstellungen löschen; dies gilt als Kündigung. Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
        </p>

        <h3>§ 8 Daten des Kunden und Datenschutz</h3>
        <p>
            Die vom Kunden erfassten Daten bleiben Eigentum des Kunden. Soweit der Anbieter personenbezogene Daten im Auftrag des Kunden verarbeitet, schließen die Parteien einen Vertrag
            zur Auftragsverarbeitung nach Art. 28 DSGVO. Mit Löschung des Kontos werden alle Daten des Kunden gelöscht, soweit keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
            Der Kunde ist dafür verantwortlich, benötigte Daten vor der Löschung zu sichern. Einzelheiten regelt die <Link to="/datenschutz">Datenschutzerklärung</Link>.
        </p>

        <h3>§ 9 Mängel</h3>
        <p>
            Der Anbieter beseitigt Mängel der Software in angemessener Frist nach Meldung. Mängel sind mit einer nachvollziehbaren Beschreibung zu melden.
            Die verschuldensunabhängige Haftung für bei Vertragsschluss vorhandene Mängel (§ 536a Abs. 1 Alt. 1 BGB) ist ausgeschlossen.
        </p>

        <h3>§ 10 Haftung</h3>
        <p>
            Der Anbieter haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit, bei Verletzung von Leben, Körper oder Gesundheit sowie nach dem Produkthaftungsgesetz.
            Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten ist die Haftung auf den vertragstypischen, vorhersehbaren Schaden begrenzt. Im Übrigen ist die Haftung für leichte Fahrlässigkeit ausgeschlossen.
            MOPS unterstützt die Planung von Wartungen, ersetzt aber nicht die Prüf- und Wartungspflichten des Kunden nach Herstellervorgaben und gesetzlichen Vorschriften.
        </p>

        <h3>§ 11 Änderungen dieser AGB</h3>
        <p>
            Der Anbieter kann diese AGB mit Wirkung für die Zukunft ändern, soweit dies für den Kunden zumutbar ist. Änderungen werden mindestens [sechs Wochen] vor Inkrafttreten per E-Mail angekündigt.
            Widerspricht der Kunde nicht bis zum Inkrafttreten, gelten sie als angenommen; auf diese Folge weist der Anbieter in der Ankündigung hin. Im Fall des Widerspruchs kann jede Seite den Vertrag zum Inkrafttreten kündigen.
        </p>

        <h3>§ 12 Schlussbestimmungen</h3>
        <p>
            Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Gerichtsstand ist [Sitz des Anbieters], soweit der Kunde Kaufmann ist.
            Sollte eine Bestimmung unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
        </p>
    </LegalPage>
);
